const membershipSubscriptionDetails = (state = null, action) => {
  if (action.type === "SET_MEMBERSHIP_SUBSCRIPTION_DETAILS_DATA") {
    return action.payload;
  } else {
    return state;
  }
  // switch (action.type) {
  //   case "SET_MEMBERSHIP_SUBSCRIPTION_DETAILS_DATA": {
  //     return action.payload;
  //   }

  //   default: {
  //     return state;
  //   }
  // }
};

export default membershipSubscriptionDetails;
